import React from 'react';
import { Switch, Route } from 'react-router-dom';
import QueueTracker from '../queues/queues';

interface iMainProps {
  clientOrg: string;
}

const Main: React.FC<iMainProps> = ({clientOrg}) =>  {
  return (
    <main>
      <Switch>
        {/* <Route exact path='/' component={ QueueTracker } /> */}
        <Route exact path='/' render={(queueTrackerProps) => <QueueTracker {...queueTrackerProps} clientOrg={clientOrg} />} />
      </Switch>
    </main>
  )
}

export default Main;